import { render, staticRenderFns } from "./DoubleSlider.vue?vue&type=template&id=0552a2b8&scoped=true&"
import script from "./DoubleSlider.vue?vue&type=script&lang=js&"
export * from "./DoubleSlider.vue?vue&type=script&lang=js&"
import style0 from "./DoubleSlider.vue?vue&type=style&index=0&id=0552a2b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0552a2b8",
  null
  
)

export default component.exports